import { render } from "./NewRelocationRequestForm.vue?vue&type=template&id=171b3718"
import script from "./NewRelocationRequestForm.vue?vue&type=script&lang=js"
export * from "./NewRelocationRequestForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__